// @ts-check
import {
    options as defaultOptions,
    nextArrow,
    prevArrow,
} from '@/global/slick-options';
import { getAll } from '@/utilities/querySelector';

jQuery(function ($) {
    const sliders = getAll('[data-card-slider]');

    sliders.forEach((slider) => {
        const size = slider.getAttribute('data-card-slider') ?? '';

        const sizeOptions = getSizeOptions(size);
        const additionalOptions = JSON.parse(
            slider.getAttribute('data-card-slider-options') ?? '{}',
        );

        if (additionalOptions?.arrowStyle === 'solid') {
            additionalOptions.nextArrow = nextArrow.replace(
                'button--ghost',
                '',
            );
            additionalOptions.prevArrow = prevArrow.replace(
                'button--ghost',
                '',
            );
        }

        $(slider).slick({
            ...defaultOptions,
            ...sizeOptions,
            ...additionalOptions,
        });
    });

    /**
     * @param {string} size
     *
     * @return {object}
     */
    function getSizeOptions(size) {
        let options = {};

        switch (size) {
            case 'tiny':
                options = {
                    slidesToShow: 9,
                    responsive: [
                        {
                            breakpoint: 1450,
                            settings: {
                                slidesToShow: 7,
                            },
                        },
                        {
                            breakpoint: 1300,
                            settings: {
                                slidesToShow: 6,
                            },
                        },
                        {
                            breakpoint: 1000,
                            settings: {
                                slidesToShow: 4,
                            },
                        },
                        {
                            breakpoint: 800,
                            settings: {
                                slidesToShow: 4,
                            },
                        },
                        {
                            breakpoint: 500,
                            settings: {
                                slidesToShow: 3,
                            },
                        },
                        {
                            breakpoint: 450,
                            settings: {
                                slidesToShow: 2,
                            },
                        },
                    ],
                };
                break;
            case 'small':
                options = {
                    slidesToShow: 4,
                    responsive: [
                        {
                            breakpoint: 1250,
                            settings: {
                                slidesToShow: 3,
                            },
                        },
                        {
                            breakpoint: 850,
                            settings: {
                                slidesToShow: 2,
                            },
                        },
                        {
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 1,
                            },
                        },
                    ],
                };
                break;
            case 'medium':
                options = {
                    slidesToShow: 3,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                            },
                        },
                        {
                            breakpoint: 850,
                            settings: {
                                slidesToShow: 1,
                            },
                        },
                    ],
                };
                break;
            case 'large':
                options = {
                    slidesToShow: 1.33,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 1,
                            },
                        },
                    ],
                };
                break;
            case 'huge':
                options = {
                    slidesToShow: 1,
                };
                break;
            default:
                break;
        }
        return options;
    }
});
